"use strict";

intellidealerAppCoreModule.factory(
  "maintenanceModeInterceptor",
  function ($q, $injector) {
    return {
      responseError: function (rejection) {
        if (rejection.status === 503) {
          // Lazy inject to prevent circular dependency
          var $location = $injector.get("$location");

          var $stateParams = $injector.get('$stateParams');
          var $rootScope = $injector.get('$rootScope');
          var logoutResource = $injector.get("logoutResource");
          var cdkAnalyticsService = $injector.get("cdkAnalyticsService");
          var locationService = $injector.get("locationService");
          var globalAlertService = $injector.get("globalAlertService");

          logoutResource.get(function () {
            $rootScope.gadimension2 = "";
            cdkAnalyticsService.logLogout();
            locationService.clearDefaultLocation();
          }, globalAlertService.handleErrorResponse);

          let library = $stateParams.library;
          if (!library) {
            library = $location.$$path.split("/")[1];
          }

          $location.url("/login/" + library.toUpperCase());
        }

        return $q.reject(rejection);
      },
    };
  }
);
